export default "__VITE_ASSET__46ceb8ab__"